const WhitePlusIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='31'
      height='31'
      viewBox='0 0 31 31'
    >
      <g
        id='Layer_2'
        data-name='Layer 2'
        transform='translate(-0.477)'
      >
        <g
          id='invisible_box'
          data-name='invisible box'
          transform='translate(0 0)'
        >
          <rect
            id='Rectangle_7543'
            data-name='Rectangle 7543'
            width='31'
            height='31'
            transform='translate(0.477)'
            fill='none'
          />
          <rect
            id='Rectangle_7544'
            data-name='Rectangle 7544'
            width='31'
            height='31'
            transform='translate(0.477)'
            fill='none'
          />
          <rect
            id='Rectangle_7545'
            data-name='Rectangle 7545'
            width='31'
            height='31'
            transform='translate(0.477)'
            fill='none'
          />
        </g>
        <g
          id='icons_Q2'
          data-name='icons Q2'
          transform='translate(1.32 1.32)'
        >
          <g
            id='Group_26495'
            data-name='Group 26495'
          >
            <path
              id='Path_142407'
              data-name='Path 142407'
              d='M16.2,2A14.139,14.139,0,1,0,26.266,6.141,14.2,14.2,0,0,0,16.2,2Zm0,25.824A11.621,11.621,0,1,1,27.824,16.2,11.621,11.621,0,0,1,16.2,27.824Z'
              transform='translate(-2 -2)'
              fill='#fff'
            />
            <path
              id='Path_142408'
              data-name='Path 142408'
              d='M26.2,18.456H21.038V13.291a1.291,1.291,0,1,0-2.582,0v5.165H13.291a1.291,1.291,0,1,0,0,2.582h5.165V26.2a1.291,1.291,0,0,0,2.582,0V21.038H26.2a1.291,1.291,0,0,0,0-2.582Z'
              transform='translate(-5.544 -5.544)'
              fill='#fff'
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default WhitePlusIcon;
